import React from "react";
import { useNavigate } from 'react-router-dom';
import "./BlogList.css";

const BlogList = ({ blogs = [], limit }) => {
    const displayedBlogs = limit ? blogs.slice(0, limit) : blogs;
    const navigate = useNavigate();

    return (
        <>
            <div className='section-title blog-section-title'>
                Our News & Blog
            </div>
            <div className="blog-list">
                {displayedBlogs.map((blog) => (
                    <div key={blog.id} className="blog-item">
                        {blog.image && <img src={blog.image} alt={blog.title} className="blog-image" />}
                        <button onClick={() => navigate(blog.link)} className="blog-title">
                            {blog.title}
                        </button>
                        <p className="blog-date">{blog.date}</p>
                        <p className="blog-excerpt">{blog.excerpt}</p>
                        <button onClick={() => navigate(blog.link)} className="read-more">
                            Read more &rarr;
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

export default BlogList;
